export default "__VITE_ASSET__BrcYV5hz__"